import React, { useState, useMemo, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { EMPTY_STRING, countriesEcncylopediaConstants } from "../../constants";
import SearchField from "../../shared/components/search/SearchField";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { countriesEncyclopediaActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";
import CountryCard from "./CountryCard";

const { ALL_COUNTRIES_ENCYCLOPEDIA } = countriesEcncylopediaConstants;

const CountriesEncyclopedia = (props) => {
  const {
    spinnerActions,
    allCountriesEncyclopedia,
    getAllCountriesEncyclopedia,
  } = props;

  const navigate = useNavigate();
  const [search, setSearch] = useState(EMPTY_STRING);

  const navigateToDetailPage = (countryEncyclopediaId) => {
    const path = `/country-encyclopedia-detail/${countryEncyclopediaId}`;
    navigate(path);
  };

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  const handleSearch = (data) => {
    setSearch(data);
  };

  // Optimize filtering with useMemo
  const filteredCountries = useMemo(() => {
    const searchQuery = search?.toLowerCase() || EMPTY_STRING;

    return allCountriesEncyclopedia.filter(({ country }) =>
      country?.name?.toLowerCase().includes(searchQuery)
    );
  }, [allCountriesEncyclopedia, search]);

  useEffect(() => {
    getAllCountriesEncyclopedia({});
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Topbar />
      {spinner(ALL_COUNTRIES_ENCYCLOPEDIA) > -1 && <MainSpinner />}
      <MainContentWrapper>
        <div className="container countries-encyclopedia">
          <div className="header">
            <SearchField
              className="d-inline-block search-input mt-0"
              value={search}
              handleSearch={(val) => handleSearch(val)}
            />
          </div>
          <div className="row g-4">
            {filteredCountries?.length > 0 ? (
              filteredCountries.map((countryEncyclopedia) => (
                <CountryCard
                  key={countryEncyclopedia.id}
                  name={countryEncyclopedia.country.name}
                  image={countryEncyclopedia.country.image}
                  navigateTo={() =>
                    navigateToDetailPage(countryEncyclopedia.id)
                  }
                />
              ))
            ) : (
              <div className="text-center my-2 py-2">No data found!</div>
            )}
          </div>
        </div>
      </MainContentWrapper>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  allCountriesEncyclopedia:
    state.countriesEncyclopediaReducer.allCountriesEncyclopedia,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  getAllCountriesEncyclopedia: (payload) =>
    dispatch(countriesEncyclopediaActions.getAllCountriesEncyclopedia(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CountriesEncyclopedia);
